import twConfig from "../../tailwind.config";
import * as _ from "lodash-es";

export const breakpoints = Object.keys(twConfig.theme.screens);

export const BREAKPOINT_MAP = _.fromPairs(
	_.map(breakpoints, (breakpoint) => [
		breakpoint,
		parseInt(
			twConfig.theme.screens[
				breakpoint as keyof typeof twConfig.theme.screens
			].replace("px", "")
		),
	])
);

export const createDisplayAtBreakpointMap = (
	displayProperty: React.CSSProperties["display"]
) => {
	return _.fromPairs(
		_.map(breakpoints, (breakpoint) => [
			breakpoint,
			`[{$breakpoint}]:${displayProperty}`,
		])
	);
};
